function checkPrivacyField(elem) {
  if (elem.checkValidity()) {
    elem.classList.remove('has-error')
    if (elem.nextElementSibling && elem.nextElementSibling.classList.contains('required-field-label')) {
      elem.nextElementSibling.remove()
    }
  } else {
    elem.classList.add('has-error')
    if (!elem.nextElementSibling || !elem.nextElementSibling.classList.contains('required-field-label')) {
      const label = document.createElement('label')
      label.classList.add('required-field-label')
      label.textContent = 'This field is required'
      elem.insertAdjacentElement('afterend', label)
    }
  }
}

document.addEventListener('turbo:load', function () {
  const form = document.getElementById('privacy_request_form')
  if (!form) return

  form.querySelectorAll('[required]').forEach(function (elem) {
    elem.addEventListener('blur', function () {
      checkPrivacyField(elem)
    })
  })

  form.addEventListener('submit', function (e) {
    if (!form.checkValidity()) {
      form.querySelectorAll('[required]').forEach(function (elem) {
        checkPrivacyField(elem)
      })
      e.preventDefault()
    }
  })
})
